<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form @submit.prevent="approveEventInscription" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.inscription.approbation') }}</h5>
          </div>

          <div class="modal-body">
            <div class="row">
              <Select2
                  :parent-id="'#'+id"
                  container-class="col-12 mb-5"
                  :multiple="false"
                  :show-search="true"
                  labelClass="form-label fs-6 text-black"
                  selectClass="form-control form-select form-select-solid rounded-end-0 border-start"
                  :name="`status-`+id"
                  :label="$t('events.participator.status')"
                  v-model="formData.status_id"
                  :is-required>
                <option v-for="stat in status" :key="stat?.id" :value="stat?.id">{{ stat?.name }}</option>
              </Select2>
            </div>
          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {ref, defineProps, onMounted, watch, computed} from "vue";
import {useStore} from "vuex";

import Button from "@/components/Button.vue"
import { useRoute } from "vue-router";
import Input from "@/components/Input.vue";
import {useEventEnums} from "@/Modules/Events/composables/eventTypes";
import Select2 from "@/components/Select2.vue";

const store = useStore()
const route = useRoute()
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  callback: {
    type: Function,
    required: false,
    default: () => {}
  },
  data: {
    type: Object,
    default: () => {}
  }
})

const { inscriptionStatus } = useEventEnums()

const status = computed(() => store.getters['events/getEventStatus'])


watch(() => props.data, (value) => {
  if(value && value.event_inscription_id) {
    formData.value.event_inscription_id = value.event_inscription_id
  }
}, {deep: true})

const isLoading = ref(false)
const formData = ref(
    {
      event_inscription_id: '',
      status: inscriptionStatus.value.APPROVED,
      status_id: '',
    }
)
function approveEventInscription() {
  isLoading.value = true
  store.dispatch('events/validateEventInscriptionRequest', formData.value)
      .then(() => {
        $("#"+props.id).modal('toggle');
        props.callback()
        window.toastr['success'](i18n.global.t('notification.event_inscription_validated'))
      })
      .catch(() => {
      })
      .finally(() => isLoading.value = false)

}


onMounted(() => {
  store.dispatch('events/loadEventStatus')
})
</script>

<style scoped></style>
